import React from "react";
import Context from "../../../Context";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import WorkdocRolesModal from "./WorkdocRolesModal";
import WorkdocRolesRole from "./WorkdocRolesRole";
import WorkdocRolesSection from "./WorkdocRolesSection";
export default class WorkdocRoles extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      roles: [],
      sections: [],
      full: false,
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    let prevItem = prevProps.item || {};
    let item = this.props.item || {};
    if (prevItem.id !== item.id) {
      this.reset();
      this.load();
    }
  }

  toggleFullMode = () => {
    this.setState((state) => {
      return {
        full: !state.full,
      };
    });
  };

  reset = () => {
    this.setState({
      full: false,
      roles: [],
      sections: [],
    });
  };

  load = async () => {
    const { item = {} } = this.props;
    this.setState({ pending: true });

    let roles = await this.context.api.qa(`/participant/list`, {
      search: [
        {
          field: "document",
          compare: "EQL",
          value: item.id,
        },
      ],
    });

    let sections = [];

    roles.forEach((role = {}) => {
      let { statelabel, activityname, state, statecode } = role;
      if (
        sections.filter(
          (s) => s.statelabel === statelabel && s.activityname === activityname
        ).length === 0
      ) {
        sections.push({ statelabel, activityname, state, statecode });
      }
    });

    this.setState({ pending: false, roles, sections });
  };

  onAfterRoleSave = () => {
    if (this.props.toggleRolesModal) {
      this.props.toggleRolesModal();
    }
    this.load();
  };

  render() {
    const { openRolesModal, item } = this.props;
    let { roles, sections, pending, full } = this.state;

    let final = item.statetypecode === "disabled" && !full;

    let rolesTotal = roles.length;
    let rolesCompleted = roles.filter((r) => r.completed).length;
    let rolesCurrent = sections.filter((s) => s.state === item.state);
    let rolesRest = rolesTotal - (final ? rolesCompleted : rolesCurrent);

    if (!full) {
      sections = sections.filter((s) => s.state === item.state);
    }

    if (pending) return <div className="spinner p-3"></div>;

    const nothingLabel = (
      <div className="small text-muted mb-2">
        Нет ни одного участника для статуса{" "}
        <EssenceStateLabel
          stateCode={item.statecode}
          stateLabel={item.statelabel}
        />{" "}
      </div>
    );

    return (
      <>
        {openRolesModal ? (
          <WorkdocRolesModal
            item={item}
            onAfterRoleSave={this.onAfterRoleSave}
            onHide={this.props.toggleRolesModal}
            sourceRole={this.props.sourceRole}
          />
        ) : null}

        <Blocker light on={pending}>
          <div className="alert workdoc-roles">
            {final && (
              <div>
                {rolesCompleted > 0 ? (
                  <>
                    {roles.map((role = {}) => {
                      if (!role.completed) return null;
                      return <WorkdocRolesRole key={role.id} role={role} />;
                    })}
                  </>
                ) : (
                  <>{nothingLabel}</>
                )}
              </div>
            )}
            {!final && !sections.length && <>{nothingLabel}</>}
            {sections.map((section = {}, idx) => {
              return (
                <div key={idx}>
                  <WorkdocRolesSection section={section} />

                  {roles.map((role = {}) => {
                    if (
                      role.statelabel !== section.statelabel ||
                      role.activityname !== section.activityname
                    )
                      return null;

                    return (
                      <WorkdocRolesRole
                        key={role.id}
                        role={role}
                        onClick={() => this.props.toggleRolesModal(role)}
                      />
                    );
                  })}
                </div>
              );
            })}

            {rolesRest > 0 && !full && (
              <div>
                <span
                  className="small   text-hover-primary cursor-pointer"
                  onClick={this.toggleFullMode}
                >
                  Есть еще участники{" "}
                  <span className="label label-secondary mr-2">
                    {rolesRest}
                  </span>
                  Показать всех?
                </span>
              </div>
            )}
          </div>
        </Blocker>
      </>
    );
  }
}
